<template>
  <div v-show="drawerVisible">
    <el-drawer title="引入工资条"
               ref="drawer"
               :visible.sync="drawerVisible"
               :close-on-press-escape="false"
               @close="colseDrawer"
               :wrapperClosable="false"
               size="78%">
      <div class="wrapper">
        <div class="row optional"></div>
        <el-row :gutter="20">
          <el-form ref="searchForm"
                   :model="searchForm"
                   label-width="70px"
                   size="small">
            <!-- <el-col :lg="5" :md="12" :sm="12" :xs="24">
              <el-form-item label="单位">
                <el-select
                  filterable
                  v-model="searchForm.companyId"
                  clearable
                  style="width: 100%"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="item in companyList"
                    :key="item.Id"
                    :label="item.customerName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :lg="5"
                    :md="12"
                    :sm="12"
                    :xs="24">
              <el-form-item label="状态">
                <el-select filterable
                           v-model="searchForm.calculateState"
                           style="width: 100%"
                           placeholder="请选择单位">
                  <el-option v-for="item in stateList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="5"
                    :md="12"
                    :sm="12"
                    :xs="24">
              <el-form-item label="关键字"
                            prop="keyWord">
                <el-input @keyup.enter.native="handleSearch"
                          v-model="searchForm.keyWord"
                          clearable
                          placeholder="请输入关键字查询"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <el-button size="small"
                     style="margin-left: 15px"
                     type="primary"
                     plain
                     @click="handleSearch"
                     icon="el-icon-search">查询</el-button>
        </el-row>
        <div class="row table">
          <MyTable :tableData="tableData"
                   :tableConfig="tableConfig"
                   tableType="selection"
                   @selectionChange="handleSelectionChange"
                   :height="tableHeight"
                   :indexFlag="true"
                   tableEmptyText="暂无数据，点击前往工资计算"
                   @EmptyBtn="navTip">
            <template v-slot:createDate="slotData">
              {{
                slotData.scope.row.createDate &&
                slotData.scope.row.createDate.slice(0, 10)
              }}
            </template>
            <template v-slot:payRollName="slotData">
              {{
                slotData.scope.row.wageTitle
                  ? slotData.scope.row.wageTitle
                  : "-"
              }}
            </template>
            <template v-slot:index="slotData">
              {{
                ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
                slotData.scope.$index +
                1
              }}
            </template>
            <template v-slot:totalMoney="slotData">
              {{
                slotData.scope.row.calculateState == 1
                  ? "-"
                  : parseFloat(slotData.scope.row.totalMoney).toFixed(2)
              }}
            </template>
            <template v-slot:operation="slotData">
              <el-button @click="editCustomerInfo(slotData.scope.row)"
                         class="chabtn"
                         size="small"
                         icon="el-icon-edit">设为发薪卡</el-button>
              <el-button @click="deleteCustomer(slotData.scope.row.id)"
                         type="danger"
                         plain
                         size="small"
                         icon="el-icon-delete">删除</el-button>
            </template>
          </MyTable>

          <Pagination style="margin-top: 10px"
                      :total="total"
                      @getNewData="SalaryCalculatePage"
                      ref="pagination" />
        </div>

        <div class="submit-bar">
          <el-button @click="
              () => {
                $router.push('/salaryCalculationList'), (drawerVisible = false);
              }
            "
                     v-if="tableData == null || tableData.length <= 0">前往工资计算</el-button>
          <el-button v-else
                     @click="colseDrawer">关 闭</el-button>
          <el-button type="primary"
                     @click="onSubmit('form')">确 定</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- <el-dialog
      title="引入工资条"
      :visible.sync="stateDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="450px"
      class="colleague-dialog"
    >
      <el-form
        ref="form"
        :model="form"
        :inline="true"
        :rules="rules"
        label-width="90px"
      >

        <el-form-item label="单位" prop="factory">
          <el-select
            v-model="form.factory"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in companyList"
              :key="item.customerName"
              :label="item.customerName"
              :value="item.customerName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="submit-bar">
        <el-button
          @click="
            () => {
              // resetForm();
              stateDialogVisible = false;
            }
          "
          >关 闭</el-button
        >

        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="onSubmit('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
    <!-- <el-dialog
      title="引入工资表"
      :visible.sync="stateDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="450px"
      class="colleague-dialog"
    >
      <el-form ref="form" :model="form" :inline="true" :rules="rules">
        <el-form-item label="单位" prop="factory">
          <el-select
            v-model="form.factory"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in companyList"
              :key="item.customerName"
              :label="item.customerName"
              :value="item.customerName"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发薪单位" prop="payUnitId">
          <el-select
            v-model="form.payUnitId"
            clearable
            filterable
            ref="mySelected"
            placeholder="请选择"
          >
            <el-option
              v-for="item in payUnitList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账户" prop="keyWord">
          <el-input
            @keyup.enter.native="handleSearch"
            v-model="form.keyWord"
            clearable
            placeholder="请输入关键字查询"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              // resetForm();
              stateDialogVisible = false;
            }
          "
          >取 消</el-button
        >
        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="changeState('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import MyTable from "@/components/Table";
export default {
  components: {
    MyTable,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: null,
      require: true,
    },
    onerow: {
      type: null,
    },
  },
  data () {
    return {
      tableName: "batchAddTable",
      tableConfig: [
        {
          field: "createDate",
          label: "创建日期",
          slotName: "createDate",
          width: 120,
          flag: true,
          align: "center",
        },
        {
          field: "projectName",
          label: "项目名称",
          align: "center",
          flag: true,
          minWidth: 140,
        },
        {
          field: "payRollName",
          label: "工资条名称",
          align: "center",
          slotName: "payRollName",
          flag: true,
          minWidth: 140,
        },
        // {
        //   field: "employingUnit",
        //   label: "单位",
        //   align: "center",
        //   flag: true,
        // },

        {
          field: "totalCount",
          label: "人数",
          align: "center",
          flag: true,
        },
        {
          field: "totalMoney",
          label: "总金额(元)",
          flag: true,
          slotName: "totalMoney",
          align: "right",
        },
      ],
      rules: {
        payUnitId: [
          {
            required: true,
            message: "请选择发薪单位",
            trigger: ["blur", "change"],
          },
        ],
        account: [
          {
            required: true,
            message: "请选择发薪账户",
            trigger: ["blur", "change"],
          },
        ],
      },
      stateList: [
        { label: "已发布", value: 5 },
        { label: "已生成", value: 3 },
        { label: "已核对", value: 6 },
      ],
      drawerVisible: false,
      form: {},
      payUnitList: [],
      PayAccountList: [],
      submitLoading: false,
      stateDialogVisible: false,
      searchForm: { calculateState: 5 },
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      companyList: [],
      tableHeight: "",
      Ids: [],
      customerIds: [],
    };
  },
  mounted () {
    this.getCompanyList();
  },
  methods: {
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getPayrollUnitList () {
      this.$api.customer.PayrollUnitList().then((res) => {
        if (res.error === false) {
          this.payUnitList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSearch () {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.SalaryCalculatePage();
    },
    addAccount () {
      this.dialogVisible = true;
    },
    colseDrawer () {
      this.resetForm();
      console.log(1);
      this.drawerVisible = false;
      this.$emit("colseDrawer");
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
    },
    selected () {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请选择一条数据");
      }
      if (this.Ids.length > 1) {
        return this.$message.warning("请选择一条数据");
      }
      this.stateDialogVisible = true;
    },
    onSubmit (formName) {
      // if (!valid) return;
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      if (this.Ids.length > 1) {
        return this.$message.warning("只能选择一条数据");
      }
      this.submitLoading = true;
      let sendData = {
        salaryId: this.Ids[0],
        companyId: this.$store.state.id,
        companyName: this.$store.state.companyName,
      };
      this.$api.salary.SalaryGrantImportCalculateData(sendData).then((res) => {
        this.submitLoading = false;
        if (res.error === false) {
          this.$message.success("引入成功");
          this.stateDialogVisible = false;
          this.colseDrawer();
          this.$router.push("salaryBehalfDetail?id=" + res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    SalaryCalculatePage () {
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        this.loading = true;

        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          calculateState: this.searchForm.calculateState,
        };

        Data = {
          stateDate: this.searchForm.stateDate,
          endDate: this.searchForm.endDate,
        };
        // console.log(sendData);
        for (let i in Data) {
          if (Data[i] != undefined) {
            sendData[i] = Data[i];
          }
        }
        this.$api.salary.SalaryCalculatePage(sendData).then((res) => {
          this.loading = false;

          if (res.error === false) {
            this.tableData = res.data.data;
            // if (this.tableData == null || this.tableData == []) {
            //   this.navTip();
            // }
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    navTip () {
      // this.$confirm("暂无已生成的工资条,请前往工资计算!", "提示", {
      //   confirmButtonText: "前往工资计算",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //   })
      //   .catch(() => {});
      this.$router.push("/salaryCalculationList");
      this.drawerVisible = false;
    },
    resetForm () {
      this.customerIds = [];
      this.form = {};
    },
  },
  watch: {
    visible (newVal) {
      this.drawerVisible = newVal;
      if (newVal == true) {
        this.SalaryCalculatePage();
      }
      if (newVal) {
        this.loading = false;
      }
    },
    drawerVisible (newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.submit-bar {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
}
.submit-bar .el-button {
  padding: 8px 20px;
}
.el-table .cell {
  white-space: pre-line !important;
}

.wrapper {
  padding: 10px 20px;
}

button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}

button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}

.number-footer {
  width: 100px;
}

.myimg {
  width: 200px;
  height: auto;
}
</style>